import axios from '../../config/axiosConfig';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  accountLoginCheckFailure,
  accountLoginCheckSuccess,
  accountLoginFailure,
  accountLoginSuccess,
  accountLogoutFailure,
  accountLogoutSuccess } from './account.actions';
import { AccountActionTypes, LoginRequest, LoginResponse } from './models';

/**
 * logs user login to db, then dispatches an action with the corresponding result
 */
export function* accountLoginAsyncSaga({payload}:{payload: LoginRequest; type: string;}): Generator {
  try {
    const response = yield axios.post<LoginResponse>('api/acctservices/login', {...payload})
      .then((res) => res.data);
    yield put(accountLoginSuccess(<LoginResponse>response));
  } catch (error) {
    yield put(accountLoginFailure(error));
  }
}

export function* accountLoginCheckAsyncSaga(): Generator {
  try {
    const response = yield axios.post<LoginResponse>('api/acctservices/checkUser')
      .then((res) => res.data);
    yield put(accountLoginCheckSuccess(<LoginResponse>response));
  } catch (error) {
    yield put(accountLoginCheckFailure(error));
  }
}

/**
 * logs user logout to db, then dispatches an action with the corresponding result
 */
export function* accountLogoutAsyncSaga(): Generator {
  try {
    const response = yield axios.post<boolean>('api/acctservices/logout')
      .then((res) => res.data);
    const payload = response as boolean;
    yield put(accountLogoutSuccess(payload));
  } catch (error) {
    yield put(accountLogoutFailure(error));
  }
}

/**
 * Listens for ACCOUNT_LOGIN_START action, dispatchs accountLoginAsyncSaga
 */
export function* accountLoginStartSaga(): Generator {
  yield takeLatest(AccountActionTypes.ACCOUNT_LOGIN_START, accountLoginAsyncSaga);
}

/**
 * Listens for ACCOUNT_LOGOUT_START action, dispatchs accountLoginAsyncSaga
 */
export function* accountLogoutStartSaga(): Generator {
  yield takeLatest(AccountActionTypes.ACCOUNT_LOGOUT_START, accountLogoutAsyncSaga);
}

export function* accountLoginCheckStartSaga(): Generator {
  yield takeLatest(AccountActionTypes.ACCOUNT_LOGIN_CHECK_START, accountLoginCheckAsyncSaga);
}

/**
 * Composite of all account sagas that are listening for external actions
 */
export function* accountSagas(): Generator {
  yield all([
    call(accountLoginStartSaga),
    call(accountLogoutStartSaga),
    call(accountLoginCheckStartSaga)
  ]);
}

export default accountSagas;